import { render } from "./AGB_De.vue?vue&type=template&id=a4c61948"
import script from "./AGB_De.vue?vue&type=script&lang=js"
export * from "./AGB_De.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\stfg.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__